import MessageService from 'message-service/message-service';
export const MLB_NATIVE_NAVCLICK = 'MLB_NATIVE_NAVCLICK';
export const MLBNATIVE_LOGIN = "MLBNATIVE_LOGIN";


class DeferredPromise {
    constructor () {
        this.dfd = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.then = this.dfd.then.bind(this.dfd);
        this.catch = this.dfd.catch.bind(this.dfd);
        this.finally = this.dfd.finally.bind(this.dfd);
        this[Symbol.toStringTag] = 'Promise';
    }
}

const noop = () => {};

const navClick = (cfg) => {
    MessageService.publish(MLB_NATIVE_NAVCLICK, cfg);
}

const scopeThis = (mlbNative, key) => {
    const func = mlbNative?.[key];
    return (typeof func === 'function') ? mlbNative?.[key].bind(mlbNative) : noop
}
class MlbNativeWrapper {
    constructor () {
        this.mlbNativePromise = new DeferredPromise();
        document.addEventListener('mlbNativeLoaded', () => this.onMlbNativeLoaded());
    }

    setData () {
        try {
            this.mlbNativePromise.resolve({
                share: scopeThis(mlbNative, 'share'),
                startTrace: scopeThis(mlbNative, 'startTrace'),
                stopTrace: scopeThis(mlbNative, 'stopTrace'),
                addTraceProperties: scopeThis(mlbNative, 'addTraceProperties'),
                getUser: scopeThis(mlbNative, 'getUser'),
                updateNav: scopeThis(mlbNative, 'updateNav'),
                updateGame: scopeThis(mlbNative, 'updateGame'),
                login: mlbNative?.login ? () => {
                    return new Promise((resolve, reject) => {
                        const loginHandler = (data) => {
                            const { detail: { status } = {}} = data;
                            document.removeEventListener(MLBNATIVE_LOGIN,loginHandler);
                            if (status === "LOGIN_SUCCESS") {
                                resolve(status);
                            } else { // abort or fails
                                reject(status);
                            }
                        };
                        document.addEventListener(MLBNATIVE_LOGIN, loginHandler);
                        mlbNative.login();
                    });
                } : undefined
            });
            if(!window?.navClick) {
                window.navClick = navClick;
            }

        } catch (error) {
            console.log('error loading mlbNative', error);
        }
    }

    onMlbNativeLoaded () {
        try {
            if (typeof mlbNative !== 'undefined') {
                mlbNative.initialize(this.setData.bind(this));
            }
        } catch (error) {
            console.log('error loading mlbNative', error);
        }
    }

    static getData () {
        if (!this.instance) {
            this.instance = new MlbNativeWrapper();
        }
        return this.instance.mlbNativePromise.then((res) => res);

    }
}

const hasGlobalInstance = !!window?.GamedayMlbNativeWrapper;

if (!hasGlobalInstance) {
    window.GamedayMlbNativeWrapper = MlbNativeWrapper.getData();
}


export default window.GamedayMlbNativeWrapper;
